export const getCookie = (cookieName: string): string => {
    const ck = document.cookie;
    if (ck.length) {
        const nameIndex = ck.indexOf(cookieName);
        if (nameIndex !== -1) {
            const valueIndex = nameIndex + cookieName.length + 1;
            const tempValueTail = ck.indexOf(';', nameIndex);
            const valueTail = tempValueTail === -1 ? ck.length : tempValueTail;
            return ck.substring(valueIndex, valueTail);
        }
    }
    return '';
};



// WEBPACK FOOTER //
// ./src/utils/cookieHelper.ts